// ===========================================
// QuickFilters — Chips de filtres rapides (segmented)
// ===========================================
import React from 'react';

const QuickFilters = ({ value, onChange, options }) => {
    return (
        <div className="quick-filters" role="tablist" aria-label="Filtres rapides">
            {options.map((opt) => {
                const isActive = value === opt.value;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        className={`quick-filter-chip ${isActive ? 'is-active' : ''}`}
                        onClick={() => onChange(opt.value)}
                    >
                        {opt.icon && <span className="quick-filter-icon">{opt.icon}</span>}
                        <span>{opt.label}</span>
                        {opt.count !== undefined && (
                            <span className="quick-filter-count">{opt.count}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export default QuickFilters;
